import React from 'react'
import { Divider, Row, Col, Form, Input, Select, InputNumber } from 'antd'
import { STORAGE_LOCATIONS, VALIDATION_RULES } from '../../utils/constants'
import { mockSuppliers, mockDepartments } from '../../utils/mockInventoryData'

const { Option } = Select

const SupplierLocationSection = ({ form, handleSupplierChange, styles }) => {
  return (
    <>
      <div className={styles.sectionHeader}>Supplier & Location</div>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            name='supplierId'
            label='Supplier'
            rules={[VALIDATION_RULES.required]}
            className={`${styles.field} ${styles.fieldRequired}`}
          >
            <Select
              placeholder='Select supplier'
              onChange={handleSupplierChange}
              showSearch
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {mockSuppliers.map((supplier) => (
                <Option key={supplier.id} value={supplier.id}>
                  {supplier.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name='department' label='Department' rules={[VALIDATION_RULES.required]}>
            <Select placeholder='Select department'>
              {mockDepartments.map((dept) => (
                <Option key={dept.id} value={dept.code}>
                  {dept.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name='storageLocation' label='Storage Location'>
            <Select placeholder='Select storage location' allowClear>
              {STORAGE_LOCATIONS.map((location) => (
                <Option key={location} value={location}>
                  {location}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item name='lotNumber' label='Lot/Batch Number'>
            <Input placeholder='Enter lot or batch number' />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name='supplierMOQ' label='Supplier MOQ' tooltip='Minimum Order Quantity required by this supplier'>
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              placeholder='Minimum Order Quantity'
              onChange={(value) => {
                // If reorder type is set to MOQ, update the reorder quantity
                const reorderType = form.getFieldValue('reorderType')
                if (reorderType === 'moq') {
                  form.setFieldsValue({ reorderQuantity: value || 0 })
                }
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}

export default SupplierLocationSection
